// extracted by mini-css-extract-plugin
export var quantity = "quantity-module--quantity--2f138";
export var quantity__button = "quantity-module--quantity__button--6e9ba";
export var quantity__input = "quantity-module--quantity__input--2d0f9";